<template>
  <div class="c-judge" v-if="judges">
    <dry :index="judgeIndex" :content="judge.content" :course="judge.course" v-for="(judge, judgeIndex) in judges" :key="judgeIndex">
      <ul class="c-judge-item-chooses" v-if="judge.chooses">
        <li
        @click="chooseAns(judge, judgeIndex, choose, chooseIndex)"
        v-for="(choose, chooseIndex) in judge.chooses" :key="chooseIndex"
        class="c-judge-item-choose"
        :class="[judge.userAnswer ? '' : 'noneChoosed' ,judge.userAnswer == chooseIndex ? 'choosed' : '', ansList[chooseIndex] === judge.answer ? 'trueSeletor' : '', trigger ? 'finish' : '']">
          <span class="c-judge-item-helper"></span>
          <p class="c-judge-item-content">{{choose ? '正确' : '错误'}}</p>
        </li>
      </ul>
    </dry>
  </div>
</template>

<script>
import Dry from './dry'

export default {
  props: {
    trigger: {
      type: Boolean,
      default: false
    },
    judges: {
      type: Array,
      default: null
    }
  },
  components: {
    Dry
  },
  data () {
    return {
      ansList: 'AB'
    }
  },
  watch: {
    trigger: function () {
      this.judges.forEach((v) => {
        if (v.answer === this.ansList[v.userAnswer]) {
          this.$parent.fraction += parseInt(v.course)
        }
      })
    }
  },
  methods: {
    chooseAns (judge, judgeIndex, choose, chooseIndex) {
      if (this.trigger) {
        return false
      }
      judge.userAnswer = chooseIndex.toString()
    }
  }
}
</script>

<style lang="scss">
.c-judge{
  max-width: 1200px;
  margin: 0 auto;
  .c-judge-item-chooses{
    .c-judge-item-choose{
      background-color: #F6F6F6;
      border-radius: 8px;
      margin-bottom: 15px;
      box-sizing: border-box;
      position: relative;
      min-height: 51px;
      vertical-align: middle;
      border: 2px solid #F6F6F6;
      cursor: pointer;
      text-indent: 0;
      display: inline-block;
      width: 335px;
      margin-right: 30px;
      max-width: 100%;
      position: relative;
      &::after{
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0 32px 32px;
        border-color: transparent transparent transparent transparent;
        position: absolute;
        bottom: 0;
        right: 0;
        content: '';
      }
      &:hover, &.choosed{
        border: 2px solid #686C71;
      }
      &.choosed{
        &::after{
          border-color: transparent transparent #686C71 transparent;
        }
        &::before{
          background-image: url('../../../static/images/hook.png');
          background-size: cover;
          position: absolute;
          width: 13px;
          height: 10px;
          content: '';
          bottom: 5px;
          right: 4px;
          z-index: 1;
        }
      }
      &.finish{
        border: 2px solid #F6F6F6;
        cursor: text;
        &:hover{
          &::after{
            display: none;
          }
        }
      }
      &.noneChoosed.finish, &.choosed.finish{
        border: 2px solid #FE5454;
        &::after{
          border-color: transparent transparent #FE5454 transparent;
          display: block;
        }
        &::before{
          background-image: url('../../../static/images/cross.png');
          background-size: cover;
          position: absolute;
          width: 11px;
          height: 11px;
          content: '';
          bottom: 3px;
          right: 3px;
          z-index: 1;
        }
      }
      &.trueSeletor.finish{
        border: 2px solid #29C23D;
        &::after{
          border-color: transparent transparent #29C23D transparent;
          display: block;
        }
        &::before{
          background-image: url('../../../static/images/hook.png');
          background-size: cover;
          position: absolute;
          width: 13px;
          height: 10px;
          content: '';
          bottom: 5px;
          right: 4px;
          z-index: 1;
        }
      }
      .c-judge-item-tag{
        position: absolute;
        left: 20px;
        top: 0px;
        line-height: 51px;
        font-size: 28px;
        font-weight: 700;
      }
      .c-judge-item-content{
        line-height: 24px;
        font-size: 14px;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        width: 100%;
      }
      .c-judge-item-helper{
        height: 51px;
        line-height: 51px;
        width: 0;
        vertical-align: middle;
      }
    }
  }
}
@media screen and (max-width: 768px){
.c-judge{
  .c-judge-item-chooses{
    display: flex;
    justify-content: space-between;
    .c-judge-item-choose{
      border-radius: 8px;
      min-height: 35px;
      margin-bottom: 15px;
      margin-right: 0;
      width: 50%;
      &:nth-child(1) {
        margin-right: 8px;
      }
      &::after{
        border-width: 0 0 20px 20px;
      }
      &.choosed{
        &::before{
          width: 9px;
          height: 7px;
          bottom: 3px;
          right: 2px;
        }
      }
      &.noneChoosed.finish, &.choosed.finish{
        &::before{
          width: 7px;
          height: 7px;
          bottom: 2px;
          right: 3px;
        }
      }
      &.trueSeletor.finish{
        &::before{
          width: 9px;
          height: 7px;
          bottom: 3px;
          right: 2px;
        }
      }
      .c-judge-item-helper{
        height: 35px;
        line-height: 35px;
      }
    }
  }
}}
</style>
